// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EZEA","buttons":"styles_buttons__1EY5L"};